<template>
  <div>
    <div class="row">
      <div class="row mt-3 text-primary">
        <h6 class="text-center">{{ $t("attentionRAMsize") }}</h6>
      </div>

      <div class="col-lg-6">
        <router-view></router-view>
      </div>
      <div class="col-lg-6 mt-3">
        <router-view v-slot="{ Component }" name="second">
          <component :is="Component" />
        </router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "VdiViewer",
  components: {},
  methods: {
    ...mapActions(["setIsPackageUnit", "setAcceptToS", "setCookieStatus"]),
  },
  computed: {
    ...mapGetters(["getAcceptToS"]),
  },

  created() {
    this.setIsPackageUnit(true);
  },
  unmounted() {
    this.setIsPackageUnit(false);
    var cookieStat = this.getCookieStatus;
    this.$store.reset();
    if(this.getAcceptToS){
      this.$store.dispatch("setAcceptToS", true);
    }
    this.$store.dispatch("setCookieStatus", cookieStat);
  },
};
</script>
